module.exports = __webpack_public_path__ + "img/image (65).ad903a4c.jpg";